// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"CustomerGroupDropdown_dropdown__65EBL"};